import { render, staticRenderFns } from "./RbuItemMappingList.vue?vue&type=template&id=5cd779d4"
import script from "./RbuItemMappingList.vue?vue&type=script&lang=js"
export * from "./RbuItemMappingList.vue?vue&type=script&lang=js"
import style0 from "./RbuItemMappingList.vue?vue&type=style&index=0&id=5cd779d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports